/* eslint no-param-reassign: ["error", { "props": false }] */
import debounce from 'lodash/debounce';
import './accordion';
import setupLazyLoadingAndAnimations from './lazy_loading';

function setupDesktopMenu() {
  const navbar = document.getElementById('gusto-navbar');
  const PAGE_OFFSET = 75;
  let closeTimer;
  let openTimer;

  const updateWithinPageClass = () => {
    const hasWithinPageClass = navbar.classList.contains('on-scroll');
    if (window.pageYOffset > PAGE_OFFSET && !hasWithinPageClass) {
      navbar.classList.add('on-scroll');
    }
    if (window.pageYOffset <= PAGE_OFFSET && hasWithinPageClass) {
      navbar.classList.remove('on-scroll');
    }
  };
  const closeMenuDropdowns = () => {
    Array.from(document.querySelectorAll('nav .accordion-js .checked')).forEach(label => {
      label.classList.remove('checked');
      label.querySelector('input').checked = false;
      label.querySelector('.menu-item-with-dropdown').setAttribute('aria-expanded', false);
    });
  };
  const closeMenuOnOutsideClick = event => {
    const openMenu = document.querySelector('nav .accordion-js input:checked');
    if (!openMenu) return;

    if (event.target.closest('nav') === null) {
      closeMenuDropdowns();
    }
  };
  const openMenuDropdown = event => {
    const input = event.target.parentElement.querySelector('input');
    if (input.checked) return;

    closeMenuDropdowns();
    input.checked = true;
    event.target.setAttribute('aria-expanded', true);
    event.target.parentElement.classList.toggle('checked');
  };

  const clearCloseTimer = () => {
    clearTimeout(closeTimer);
  };

  const clearOpenTimer = () => {
    clearTimeout(openTimer);
  };

  const startCloseTimer = () => {
    clearOpenTimer();
    closeTimer = setTimeout(closeMenuDropdowns, 200);
  };

  const startOpenTimer = event => {
    openTimer = setTimeout(() => {
      openMenuDropdown(event);
    }, 75);
    clearCloseTimer();
  };

  document.addEventListener('scroll', () => {
    updateWithinPageClass();
    closeMenuDropdowns();
  });

  const menuTitles = Array.from(document.querySelectorAll('nav .menu-item-with-dropdown'));
  menuTitles.forEach(title => {
    title.addEventListener('mouseenter', startOpenTimer);
    title.addEventListener('click', () => false);
    title.addEventListener('mouseleave', startCloseTimer);
  });

  document.addEventListener('click', closeMenuOnOutsideClick);

  const menuContent = Array.from(document.querySelectorAll('.menu-content'));
  menuContent.forEach(mc => {
    mc.addEventListener('mouseenter', clearCloseTimer);
    mc.addEventListener('mouseleave', startCloseTimer);
    mc.addEventListener('click', closeMenuDropdowns);
  });

  // Make sure subnav is not closing for accountants and resources
  [
    document.querySelector('.menu-content-accountants'),
    document.querySelector('.menu-content-resources'),
    document.querySelector('.menu-content-built-for-you'),
  ].forEach(selector => {
    selector.addEventListener('mouseenter', clearCloseTimer);
    selector.addEventListener('mouseleave', startCloseTimer);
    selector.addEventListener('click', closeMenuDropdowns);
  });

  updateWithinPageClass();
}

function setupMobileMenu() {
  const html = document.querySelector('html');
  const burgerColumn = document.getElementById('gusto-burger-col');
  const burger = document.getElementById('gusto-burger');
  const mobileMenu = document.getElementById('gusto-mobile-menu');
  let savePrevScrollY = 0;
  const toggleMobileMenu = () => {
    // animate hamburger and show the mobile menu:
    burger.classList.toggle('x');
    mobileMenu.classList.toggle('show-mobile-menu');

    html.classList.toggle('freezePage');

    if (html.classList.contains('freezePage')) {
      savePrevScrollY = window.scrollY;
    } else {
      window.scrollTo(0, savePrevScrollY);
    }
  };

  burgerColumn.addEventListener('click', toggleMobileMenu);
}

window.addEventListener(
  'load',
  () => {
    setupDesktopMenu();
    setupMobileMenu();
    setupLazyLoadingAndAnimations();
  },
  { once: true }
);
